/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { brandingsUpdate } from '../../axios/brandingsUpdate'
import type {
	BrandingsUpdateError,
	BrandingsUpdatePathParams,
	BrandingsUpdateRequest,
	BrandingsUpdateResponse,
} from '../../types/BrandingsUpdate'

export const brandingsUpdateMutationKey = () => [{ url: '/brandings/:branding' }] as const

export type BrandingsUpdateMutationKey = ReturnType<typeof brandingsUpdateMutationKey>

export type BrandingsUpdateVariables = {
	branding: BrandingsUpdatePathParams['branding']
	data: BrandingsUpdateRequest
}

/** @see backend/nexus/modules/Branding/Http/Controllers/BrandingController.php BrandingController::update */
export function useBrandingsUpdate<TContext = unknown>(
	options?: UseMutationOptions<
		BrandingsUpdateResponse,
		AxiosError<BrandingsUpdateError>,
		BrandingsUpdateVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: brandingsUpdateMutationKey(),
		mutationFn: ({ branding, data }: BrandingsUpdateVariables) =>
			brandingsUpdate(branding, data, config).then(res => res.data),
		...options,
	})
}
